// // class FacetFiltersForm extends HTMLElement {
// //   constructor() {
// //     super();
    
// //     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

// //     this.debouncedOnSubmit = debounce((event) => {
// //       this.onSubmitHandler(event);
// //     }, 500);
    

// //     const facetForm = this.querySelector('form');
// //     facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

// //     const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
// //     if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

// //     const parentElement = document.querySelector('.collection-drawer-collapse-left');
// //     this.drawerCollapse(parentElement);
// //   }
// //   /* custom open drawer */
// //   drawerCollapse(parentElement) {
// //     if(parentElement){
// //       const btnOpen = this.querySelector('.drawer-collapse-btn');
// //       const sideBar = parentElement.querySelector('.sidebar-collapse-left');
// //       const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
// //       if (!btnOpen || !parentElement || !sideBar || !btnClose) {
// //         return;
// //       }
// //       btnOpen.addEventListener('click', function() {
// //         btnOpen.classList.toggle('open');
// //         sideBar.classList.toggle('open');
// //       });
    
// //       btnClose.addEventListener('click', function() {
// //         btnOpen.classList.remove('open');
// //         sideBar.classList.remove('open');
// //       });
// //     }
// //   }
// //   static closeDrawer(parentElement){
// //     if(parentElement){
// //       const btnOpen = parentElement.querySelector('.drawer-collapse-btn');
// //       const sideBar = parentElement.querySelector('.sidebar-collapse-left');
// //       const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
// //       btnClose.addEventListener('click', function() {
// //         btnOpen.classList.remove('open');
// //         sideBar.classList.remove('open');
// //       });
// //     }
   
// //   }
  
// //   static setListeners() {
// //     const onHistoryChange = (event) => {
// //       const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
// //       if (searchParams === FacetFiltersForm.searchParamsPrev) return;
// //       FacetFiltersForm.renderPage(searchParams, null, false);
// //     }
// //     window.addEventListener('popstate', onHistoryChange);
// //   }

// //   static toggleActiveFacets(disable = true) {
// //     document.querySelectorAll('.js-facet-remove').forEach((element) => {
// //       element.classList.toggle('disabled', disable);
// //     });
// //   }

// //   static renderPage(searchParams, event, updateURLHash = true) {
// //     FacetFiltersForm.searchParamsPrev = searchParams;
// //     const sections = FacetFiltersForm.getSections();
// //     const countContainer = document.getElementById('ProductCount');
// //     const countContainerDesktop = document.getElementById('ProductCountDesktop');
// //     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
// //     if (countContainer){
// //       countContainer.classList.add('loading');
// //     }
// //     if (countContainerDesktop){
// //       countContainerDesktop.classList.add('loading');
// //     }

// //     sections.forEach((section) => {
// //       const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
// //       const filterDataUrl = element => element.url === url;

// //       FacetFiltersForm.filterData.some(filterDataUrl) ?
// //         FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
// //         FacetFiltersForm.renderSectionFromFetch(url, event);
// //     });

// //     if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
// //   }

// //   static renderSectionFromFetch(url, event) {
// //     fetch(url)
// //       .then(response => response.text())
// //       .then((responseText) => {
// //         const html = responseText;
// //         FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
// //         FacetFiltersForm.renderFilters(html, event);
// //         FacetFiltersForm.renderProductGridContainer(html);
// //         FacetFiltersForm.renderProductCount(html);
        
// //       });
// //   }

// //   static renderSectionFromCache(filterDataUrl, event) {
// //     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
// //     FacetFiltersForm.renderFilters(html, event);
// //     FacetFiltersForm.renderProductGridContainer(html);
// //     FacetFiltersForm.renderProductCount(html);
    
    
// //   }
// //   static renderReview() {
// //     if (window.SPR && theme.review ) {
// //       if ($('.shopify-product-reviews-badge').length > 0) {
// //         return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
// //       };
// //     }
// //     if(theme.review && typeof jdgm !== 'undefined' ){
// //       return jdgm.customizeBadges();
// //     }
    
// //   }
// //   static renderProductGridContainer(html) {
// //     document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
// //   }

// //   static renderProductCount(html) {
// //     const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
// //     const container = document.getElementById('ProductCount');
// //     const containerDesktop = document.getElementById('ProductCountDesktop');
// //     const getpagi = document.querySelector('.AjaxinatePagination');
    
// //     container.innerHTML = count;
// //     container.classList.remove('loading');
// //     if (containerDesktop) {
// //       containerDesktop.innerHTML = count;
// //       containerDesktop.classList.remove('loading');
// //     }
// //     if(typeof(getpagi) !== "undefined" && getpagi !== null){
// //       const elem = getpagi.getAttribute('data-pagination');
// //       var endlessScroll = new Ajaxinate({
// //         container: '.AjaxinateLoop',
// //         pagination: '.AjaxinatePagination',
// //         loadingText: '<span class="loader-line"></span>',
// //         method: elem == 'scroll' ? 'scroll' : 'click',
// //         callback:function(){
// //           jdgm.customizeBadges();
// //         }
// //       });
// //     }
// //     theme.wishlist.load();
// //     theme.compare.load();
// //     //theme.countdown.load();
// //     theme.swatchCard2.load();
// //     FacetFiltersForm.renderReview();
    
// //   }

// //   static renderFilters(html, event) {
// //     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

// //     const facetDetailsElements =
// //       parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
// //     const matchesIndex = (element) => {
// //       const jsFilter = event ? event.target.closest('.js-filter') : undefined;
// //       return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
// //     }
// //     const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
// //     const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

// //     facetsToRender.forEach((element) => {
// //       document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
// //     });

// //     FacetFiltersForm.renderActiveFacets(parsedHTML);
// //     FacetFiltersForm.renderAdditionalElements(parsedHTML);

// //     if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
// //     const parentElement = document.querySelector('.collection-drawer-collapse-left');
// //     FacetFiltersForm.closeDrawer(parentElement);
    
// //   }

// //   static renderActiveFacets(html) {
// //     const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

// //     activeFacetElementSelectors.forEach((selector) => {
// //       const activeFacetsElement = html.querySelector(selector);
// //       if (!activeFacetsElement) return;
// //       document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
// //     })

// //     FacetFiltersForm.toggleActiveFacets(false);
// //   }

// //   static renderAdditionalElements(html) {
// //     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

// //     mobileElementSelectors.forEach((selector) => {
// //       if (!html.querySelector(selector)) return;
// //       document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
// //     });

// //     document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
// //   }

// //   static renderCounts(source, target) {
// //     const targetElement = target.querySelector('.facets__selected');
// //     const sourceElement = source.querySelector('.facets__selected');

// //     const targetElementAccessibility = target.querySelector('.facets__summary');
// //     const sourceElementAccessibility = source.querySelector('.facets__summary');

// //     if (sourceElement && targetElement) {
// //       target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
// //     }

// //     if (targetElementAccessibility && sourceElementAccessibility) {
// //       target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
// //     }
// //   }

// //   static updateURLHash(searchParams) {
// //     history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
// //   }

// //   static getSections() {
// //     return [
// //       {
// //         section: document.getElementById('product-grid').dataset.id,
// //       }
// //     ]
// //   }

// //   createSearchParams(form) {
// //     const formData = new FormData(form);
// //     return new URLSearchParams(formData).toString();
// //   }

// //   onSubmitForm(searchParams, event) {
// //     FacetFiltersForm.renderPage(searchParams, event);
// //   }

// //   onSubmitHandler(event) {
// //     event.preventDefault();
// //     const sortFilterForms = document.querySelectorAll('facet-filters-form form');
// //     if (event.srcElement.className == 'mobile-facets__checkbox') {
// //       const searchParams = this.createSearchParams(event.target.closest('form'))
// //       this.onSubmitForm(searchParams, event)
// //     } else {
// //       const forms = [];
// //       const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

// //       sortFilterForms.forEach((form) => {
// //         if (!isMobile) {
// //           if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
// //             const noJsElements = document.querySelectorAll('.no-js-list');
// //             noJsElements.forEach((el) => el.remove());
// //             forms.push(this.createSearchParams(form));
// //           }
// //         } else if (form.id === 'FacetFiltersFormMobile') {
// //           forms.push(this.createSearchParams(form));
// //         }
// //       });
// //       this.onSubmitForm(forms.join('&'), event)
// //     }
// //   }

// //   onActiveFilterClick(event) {
// //     event.preventDefault();
// //     FacetFiltersForm.toggleActiveFacets();
// //     const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
// //     FacetFiltersForm.renderPage(url);
// //   }
// // }

// // FacetFiltersForm.filterData = [];
// // FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// // FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// // customElements.define('facet-filters-form', FacetFiltersForm);
// // FacetFiltersForm.setListeners();

// // class PriceRange extends HTMLElement {
// //   constructor() {
// //     super();
// //     this.querySelectorAll('input')
// //       .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
  
// //     this.setMinAndMaxValues();
// //     this.noUifilter();
// //   }
// //   connectedCallback(){
// //     this.noUifilter();
// //   }
// //   onRangeChange(event) {
   
// //     this.adjustToValidValues(event.currentTarget);
// //     this.setMinAndMaxValues();
// //     this.noUifilter();
    
// //   }

// //   setMinAndMaxValues() {
// //     const inputs = this.querySelectorAll('input');
// //     const minInput = inputs[0];
// //     const maxInput = inputs[1];
// //     if (maxInput.value) minInput.setAttribute('max', maxInput.value);
// //     if (minInput.value) maxInput.setAttribute('min', minInput.value);
// //     if (minInput.value === '') maxInput.setAttribute('min', 0);
// //     if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
// //   }

// //   adjustToValidValues(input) {
// //     const value = Number(input.value);
// //     const min = Number(input.getAttribute('min'));
// //     const max = Number(input.getAttribute('max'));

// //     if (value < min) input.value = min;
// //     if (value > max) input.value = max;
// //   }
  

// //   noUifilter() {
// //     var sliderRange = this.querySelector(".slider-range");
// //     const inputs = this.querySelectorAll('input');
// //     const minInput = inputs[0];
// //     const maxInput = inputs[1];
// //     var minValue = parseFloat(minInput.value);
// //     if (isNaN(minValue)) {
// //       minValue = 0;
// //     }
  
// //     var event = new CustomEvent('input');
// //     var form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
// //     if (!sliderRange.classList.contains("noUi-target")) {
// //       noUiSlider.create(sliderRange, {
// //         start: [minValue, maxInput.value === '' ? parseFloat(maxInput.getAttribute('max')) : parseFloat(maxInput.value)],
// //         connect: true,
// //         step: 1,
// //         range: {
// //           'min': 0,
// //           'max': parseFloat(maxInput.getAttribute('max'))
// //         }
// //       });
// //       sliderRange.noUiSlider.on("change", function(values, handle) {
// //         if (handle === 0) {
// //           minInput.value = values[handle];
// //         }
// //         if (handle === 1) {
// //           maxInput.value = values[handle];
// //         }
// //       });
// //       sliderRange.noUiSlider.on('change', function(values) {
// //         form.querySelector('form').dispatchEvent(event);
// //       });
  
// //       minInput.addEventListener('change', function() {
// //         var minValue = parseFloat(minInput.value);
// //         setTimeout(function() {
// //           sliderRange.noUiSlider.set([minValue, null]);
// //         }, 0);
// //       });
  
// //       maxInput.addEventListener('change', function() {
// //         var maxValue = parseFloat(maxInput.value);
// //         setTimeout(function() {
// //           sliderRange.noUiSlider.set([null, maxValue]);
// //         }, 0);
// //       });
// //     }
// //   }
  

// // }

// // customElements.define('price-range', PriceRange);

// // class FacetRemove extends HTMLElement {
// //   constructor() {
// //     super();
// //     const facetLink = this.querySelector('a');
// //     facetLink.setAttribute('role', 'button');
// //     facetLink.addEventListener('click', this.closeFilter.bind(this));
// //     facetLink.addEventListener('keyup', (event) => {
// //       event.preventDefault();
// //       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
// //     });
    
// //   }

// //   closeFilter(event) {
// //     event.preventDefault();
// //     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
// //     form.onActiveFilterClick(event);
// //   }
// // }

// // customElements.define('facet-remove', FacetRemove);


// class FacetFiltersForm extends HTMLElement {
//   constructor() {
//     super();
    
//     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

//     this.debouncedOnSubmit = debounce((event) => {
//       this.onSubmitHandler(event);
//     }, 500);
    

//     const facetForm = this.querySelector('form');
//     facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

//     const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
//     if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

//     const parentElement = document.querySelector('.collection-drawer-collapse-left');
//     this.drawerCollapse(parentElement);
//   }
//   /* custom open drawer */
//   drawerCollapse(parentElement) {
//     if(parentElement){
//       const btnOpen = this.querySelector('.drawer-collapse-btn');
//       const sideBar = parentElement.querySelector('.sidebar-collapse-left');
//       const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
//       if (!btnOpen || !parentElement || !sideBar || !btnClose) {
//         return;
//       }
//       btnOpen.addEventListener('click', function() {
//         btnOpen.classList.toggle('open');
//         sideBar.classList.toggle('open');
//       });
    
//       btnClose.addEventListener('click', function() {
//         btnOpen.classList.remove('open');
//         sideBar.classList.remove('open');
//       });
//     }
//   }
//   static closeDrawer(parentElement){
//     if(parentElement){
//       const btnOpen = parentElement.querySelector('.drawer-collapse-btn');
//       const sideBar = parentElement.querySelector('.sidebar-collapse-left');
//       const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
//       btnClose.addEventListener('click', function() {
//         btnOpen.classList.remove('open');
//         sideBar.classList.remove('open');
//       });
//     }
   
//   }
  
//   static setListeners() {
//     const onHistoryChange = (event) => {
//       const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
//       if (searchParams === FacetFiltersForm.searchParamsPrev) return;
//       FacetFiltersForm.renderPage(searchParams, null, false);
//     }
//     window.addEventListener('popstate', onHistoryChange);
//   }

//   static toggleActiveFacets(disable = true) {
//     document.querySelectorAll('.js-facet-remove').forEach((element) => {
//       element.classList.toggle('disabled', disable);
//     });
//   }

//   static renderPage(searchParams, event, updateURLHash = true) {
//     FacetFiltersForm.searchParamsPrev = searchParams;
//     const sections = FacetFiltersForm.getSections();
//     const countContainer = document.getElementById('ProductCount');
//     const countContainerDesktop = document.getElementById('ProductCountDesktop');
//     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
//     if (countContainer){
//       countContainer.classList.add('loading');
//     }
//     if (countContainerDesktop){
//       countContainerDesktop.classList.add('loading');
//     }

//     sections.forEach((section) => {
//       const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
//       const filterDataUrl = element => element.url === url;

//       FacetFiltersForm.filterData.some(filterDataUrl) ?
//         FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
//         FacetFiltersForm.renderSectionFromFetch(url, event);
//     });

//     if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
//   }

//   static renderSectionFromFetch(url, event) {
//     fetch(url)
//       .then(response => response.text())
//       .then((responseText) => {
//         const html = responseText;
//         FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
//         FacetFiltersForm.renderFilters(html, event);
//         FacetFiltersForm.renderProductGridContainer(html);
//         FacetFiltersForm.renderProductCount(html);
        
//       });
//   }

//   static renderSectionFromCache(filterDataUrl, event) {
//     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
//     FacetFiltersForm.renderFilters(html, event);
//     FacetFiltersForm.renderProductGridContainer(html);
//     FacetFiltersForm.renderProductCount(html);
    
    
//   }
//   static renderReview() {
//     if (window.SPR && theme.review ) {
//       if ($('.shopify-product-reviews-badge').length > 0) {
//         return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
//       };
//     }
//     if(theme.review && typeof jdgm !== 'undefined' ){
//       return jdgm.customizeBadges();
//     }
    
//   }
//   static renderProductGridContainer(html) {
//     document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
//   }

//   static renderProductCount(html) {
//     const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
//     const container = document.getElementById('ProductCount');
//     const containerDesktop = document.getElementById('ProductCountDesktop');
//     const getpagi = document.querySelector('.AjaxinatePagination');
    
//     container.innerHTML = count;
//     container.classList.remove('loading');
//     if (containerDesktop) {
//       containerDesktop.innerHTML = count;
//       containerDesktop.classList.remove('loading');
//     }
//     if(typeof(getpagi) !== "undefined" && getpagi !== null){
//       const elem = getpagi.getAttribute('data-pagination');
//       var endlessScroll = new Ajaxinate({
//         container: '.AjaxinateLoop',
//         pagination: '.AjaxinatePagination',
//         loadingText: '<span class="loader-line"></span>',
//         method: elem == 'scroll' ? 'scroll' : 'click',
//         callback:function(){
//           jdgm.customizeBadges();
//         }
//       });
//     }
//     theme.wishlist.load();
//     theme.compare.load();
//     //theme.countdown.load();
//     theme.swatchCard2.load();
//     FacetFiltersForm.renderReview();
    
//   }

//   static renderFilters(html, event) {
//     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

//     const facetDetailsElements =
//       parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
//     const matchesIndex = (element) => {
//       const jsFilter = event ? event.target.closest('.js-filter') : undefined;
//       return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
//     }
//     const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
//     const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

//     facetsToRender.forEach((element) => {
//       document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
//     });

//     FacetFiltersForm.renderActiveFacets(parsedHTML);
//     FacetFiltersForm.renderAdditionalElements(parsedHTML);

//     if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
//     const parentElement = document.querySelector('.collection-drawer-collapse-left');
//     FacetFiltersForm.closeDrawer(parentElement);
    
//   }

//   static renderActiveFacets(html) {
//     const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

//     activeFacetElementSelectors.forEach((selector) => {
//       const activeFacetsElement = html.querySelector(selector);
//       if (!activeFacetsElement) return;
//       document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
//     })

//     FacetFiltersForm.toggleActiveFacets(false);
//   }

//   static renderAdditionalElements(html) {
//     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.collection-category-name-title'];

//     mobileElementSelectors.forEach((selector) => {
//       const targetElement = document.querySelector(selector);
//       const sourceElement = html.querySelector(selector);
//       if (!targetElement || !sourceElement) return;
//       targetElement.innerHTML = sourceElement.innerHTML;
//     });

//     document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
//   }

//   static renderCounts(source, target) {
//     const targetElement = target.querySelector('.facets__selected');
//     const sourceElement = source.querySelector('.facets__selected');

//     const targetElementAccessibility = target.querySelector('.facets__summary');
//     const sourceElementAccessibility = source.querySelector('.facets__summary');

//     if (sourceElement && targetElement) {
//       target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
//     }

//     if (targetElementAccessibility && sourceElementAccessibility) {
//       target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
//     }
//   }

//   static updateURLHash(searchParams) {
//     history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
//   }

//   static getSections() {
//     return [
//       {
//         section: document.getElementById('product-grid').dataset.id,
//       }
//     ]
//   }

//   createSearchParams(form) {
//     const formData = new FormData(form);
//     return new URLSearchParams(formData).toString();
//   }

//   onSubmitForm(searchParams, event) {
//     FacetFiltersForm.renderPage(searchParams, event);
//   }

//   onSubmitHandler(event) {
//     event.preventDefault();
//     const sortFilterForms = document.querySelectorAll('facet-filters-form form');
//     if (event.srcElement.className == 'mobile-facets__checkbox') {
//       const searchParams = this.createSearchParams(event.target.closest('form'))
//       this.onSubmitForm(searchParams, event)
//     } else {
//       const forms = [];
//       const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

//       sortFilterForms.forEach((form) => {
//         if (!isMobile) {
//           if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
//             const noJsElements = document.querySelectorAll('.no-js-list');
//             noJsElements.forEach((el) => el.remove());
//             forms.push(this.createSearchParams(form));
//           }
//         } else if (form.id === 'FacetFiltersFormMobile') {
//           forms.push(this.createSearchParams(form));
//         }
//       });
//       this.onSubmitForm(forms.join('&'), event)
//     }
//   }

//   onActiveFilterClick(event) {
//     event.preventDefault();
//     FacetFiltersForm.toggleActiveFacets();
//     const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
//     FacetFiltersForm.renderPage(url);
//   }
// }

// FacetFiltersForm.filterData = [];
// FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// customElements.define('facet-filters-form', FacetFiltersForm);
// FacetFiltersForm.setListeners();

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('input')
//       .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
  
//     this.setMinAndMaxValues();
//     this.noUifilter();
//   }
//   connectedCallback(){
//     this.noUifilter();
//   }
//   onRangeChange(event) {
   
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//     this.noUifilter();
    
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     if (maxInput.value) minInput.setAttribute('max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('min', 0);
//     if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('min'));
//     const max = Number(input.getAttribute('max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }
  

//   noUifilter() {
//     var sliderRange = this.querySelector(".slider-range");
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     var minValue = parseFloat(minInput.value);
//     if (isNaN(minValue)) {
//       minValue = 0;
//     }
  
//     var event = new CustomEvent('input');
//     var form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//     if (!sliderRange.classList.contains("noUi-target")) {
//       noUiSlider.create(sliderRange, {
//         start: [minValue, maxInput.value === '' ? parseFloat(maxInput.getAttribute('max')) : parseFloat(maxInput.value)],
//         connect: true,
//         step: 1,
//         range: {
//           'min': 0,
//           'max': parseFloat(maxInput.getAttribute('max'))
//         }
//       });
//       sliderRange.noUiSlider.on("change", function(values, handle) {
//         if (handle === 0) {
//           minInput.value = values[handle];
//         }
//         if (handle === 1) {
//           maxInput.value = values[handle];
//         }
//       });
//       sliderRange.noUiSlider.on('change', function(values) {
//         form.querySelector('form').dispatchEvent(event);
//       });
  
//       minInput.addEventListener('change', function() {
//         var minValue = parseFloat(minInput.value);
//         setTimeout(function() {
//           sliderRange.noUiSlider.set([minValue, null]);
//         }, 0);
//       });
  
//       maxInput.addEventListener('change', function() {
//         var maxValue = parseFloat(maxInput.value);
//         setTimeout(function() {
//           sliderRange.noUiSlider.set([null, maxValue]);
//         }, 0);
//       });
//     }
//   }
  

// }

// customElements.define('price-range', PriceRange);

// class FacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     const facetLink = this.querySelector('a');
//     facetLink.setAttribute('role', 'button');
//     facetLink.addEventListener('click', this.closeFilter.bind(this));
//     facetLink.addEventListener('keyup', (event) => {
//       event.preventDefault();
//       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
//     });
    
//   }

//   closeFilter(event) {
//     event.preventDefault();
//     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//     form.onActiveFilterClick(event);
//   }
// }

// customElements.define('facet-remove', FacetRemove);

// class FacetFiltersForm extends HTMLElement {
//   constructor() {
//     super();
    
//     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

//     this.debouncedOnSubmit = debounce((event) => {
//       this.onSubmitHandler(event);
//     }, 500);
    

//     const facetForm = this.querySelector('form');
//     facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

//     const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
//     if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

//     const parentElement = document.querySelector('.collection-drawer-collapse-left');
//     this.drawerCollapse(parentElement);
//   }
//   /* custom open drawer */
//   drawerCollapse(parentElement) {
//     if(parentElement){
//       const btnOpen = this.querySelector('.drawer-collapse-btn');
//       const sideBar = parentElement.querySelector('.sidebar-collapse-left');
//       const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
//       if (!btnOpen || !parentElement || !sideBar || !btnClose) {
//         return;
//       }
//       btnOpen.addEventListener('click', function() {
//         btnOpen.classList.toggle('open');
//         sideBar.classList.toggle('open');
//       });
    
//       btnClose.addEventListener('click', function() {
//         btnOpen.classList.remove('open');
//         sideBar.classList.remove('open');
//       });
//     }
//   }
//   static closeDrawer(parentElement){
//     if(parentElement){
//       const btnOpen = parentElement.querySelector('.drawer-collapse-btn');
//       const sideBar = parentElement.querySelector('.sidebar-collapse-left');
//       const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
//       btnClose.addEventListener('click', function() {
//         btnOpen.classList.remove('open');
//         sideBar.classList.remove('open');
//       });
//     }
   
//   }
  
//   static setListeners() {
//     const onHistoryChange = (event) => {
//       const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
//       if (searchParams === FacetFiltersForm.searchParamsPrev) return;
//       FacetFiltersForm.renderPage(searchParams, null, false);
//     }
//     window.addEventListener('popstate', onHistoryChange);
//   }

//   static toggleActiveFacets(disable = true) {
//     document.querySelectorAll('.js-facet-remove').forEach((element) => {
//       element.classList.toggle('disabled', disable);
//     });
//   }

//   static renderPage(searchParams, event, updateURLHash = true) {
//     FacetFiltersForm.searchParamsPrev = searchParams;
//     const sections = FacetFiltersForm.getSections();
//     const countContainer = document.getElementById('ProductCount');
//     const countContainerDesktop = document.getElementById('ProductCountDesktop');
//     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
//     if (countContainer){
//       countContainer.classList.add('loading');
//     }
//     if (countContainerDesktop){
//       countContainerDesktop.classList.add('loading');
//     }

//     sections.forEach((section) => {
//       const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
//       const filterDataUrl = element => element.url === url;

//       FacetFiltersForm.filterData.some(filterDataUrl) ?
//         FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
//         FacetFiltersForm.renderSectionFromFetch(url, event);
//     });

//     if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
//   }

//   static renderSectionFromFetch(url, event) {
//     fetch(url)
//       .then(response => response.text())
//       .then((responseText) => {
//         const html = responseText;
//         FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
//         FacetFiltersForm.renderFilters(html, event);
//         FacetFiltersForm.renderProductGridContainer(html);
//         FacetFiltersForm.renderProductCount(html);
        
//       });
//   }

//   static renderSectionFromCache(filterDataUrl, event) {
//     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
//     FacetFiltersForm.renderFilters(html, event);
//     FacetFiltersForm.renderProductGridContainer(html);
//     FacetFiltersForm.renderProductCount(html);
    
    
//   }
//   static renderReview() {
//     if (window.SPR && theme.review ) {
//       if ($('.shopify-product-reviews-badge').length > 0) {
//         return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
//       };
//     }
//     if(theme.review && typeof jdgm !== 'undefined' ){
//       return jdgm.customizeBadges();
//     }
    
//   }
//   static renderProductGridContainer(html) {
//     document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
//   }

//   static renderProductCount(html) {
//     const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
//     const container = document.getElementById('ProductCount');
//     const containerDesktop = document.getElementById('ProductCountDesktop');
//     const getpagi = document.querySelector('.AjaxinatePagination');
    
//     container.innerHTML = count;
//     container.classList.remove('loading');
//     if (containerDesktop) {
//       containerDesktop.innerHTML = count;
//       containerDesktop.classList.remove('loading');
//     }
//     if(typeof(getpagi) !== "undefined" && getpagi !== null){
//       const elem = getpagi.getAttribute('data-pagination');
//       var endlessScroll = new Ajaxinate({
//         container: '.AjaxinateLoop',
//         pagination: '.AjaxinatePagination',
//         loadingText: '<span class="loader-line"></span>',
//         method: elem == 'scroll' ? 'scroll' : 'click',
//         callback:function(){
//           jdgm.customizeBadges();
//         }
//       });
//     }
//     theme.wishlist.load();
//     theme.compare.load();
//     //theme.countdown.load();
//     theme.swatchCard2.load();
//     FacetFiltersForm.renderReview();
    
//   }

//   static renderFilters(html, event) {
//     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

//     const facetDetailsElements =
//       parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
//     const matchesIndex = (element) => {
//       const jsFilter = event ? event.target.closest('.js-filter') : undefined;
//       return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
//     }
//     const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
//     const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

//     facetsToRender.forEach((element) => {
//       document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
//     });

//     FacetFiltersForm.renderActiveFacets(parsedHTML);
//     FacetFiltersForm.renderAdditionalElements(parsedHTML);

//     if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
//     const parentElement = document.querySelector('.collection-drawer-collapse-left');
//     FacetFiltersForm.closeDrawer(parentElement);
    
//   }

//   static renderActiveFacets(html) {
//     const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

//     activeFacetElementSelectors.forEach((selector) => {
//       const activeFacetsElement = html.querySelector(selector);
//       if (!activeFacetsElement) return;
//       document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
//     })

//     FacetFiltersForm.toggleActiveFacets(false);
//   }

//   static renderAdditionalElements(html) {
//     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

//     mobileElementSelectors.forEach((selector) => {
//       if (!html.querySelector(selector)) return;
//       document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
//     });

//     document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
//   }

//   static renderCounts(source, target) {
//     const targetElement = target.querySelector('.facets__selected');
//     const sourceElement = source.querySelector('.facets__selected');

//     const targetElementAccessibility = target.querySelector('.facets__summary');
//     const sourceElementAccessibility = source.querySelector('.facets__summary');

//     if (sourceElement && targetElement) {
//       target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
//     }

//     if (targetElementAccessibility && sourceElementAccessibility) {
//       target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
//     }
//   }

//   static updateURLHash(searchParams) {
//     history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
//   }

//   static getSections() {
//     return [
//       {
//         section: document.getElementById('product-grid').dataset.id,
//       }
//     ]
//   }

//   createSearchParams(form) {
//     const formData = new FormData(form);
//     return new URLSearchParams(formData).toString();
//   }

//   onSubmitForm(searchParams, event) {
//     FacetFiltersForm.renderPage(searchParams, event);
//   }

//   onSubmitHandler(event) {
//     event.preventDefault();
//     const sortFilterForms = document.querySelectorAll('facet-filters-form form');
//     if (event.srcElement.className == 'mobile-facets__checkbox') {
//       const searchParams = this.createSearchParams(event.target.closest('form'))
//       this.onSubmitForm(searchParams, event)
//     } else {
//       const forms = [];
//       const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

//       sortFilterForms.forEach((form) => {
//         if (!isMobile) {
//           if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
//             const noJsElements = document.querySelectorAll('.no-js-list');
//             noJsElements.forEach((el) => el.remove());
//             forms.push(this.createSearchParams(form));
//           }
//         } else if (form.id === 'FacetFiltersFormMobile') {
//           forms.push(this.createSearchParams(form));
//         }
//       });
//       this.onSubmitForm(forms.join('&'), event)
//     }
//   }

//   onActiveFilterClick(event) {
//     event.preventDefault();
//     FacetFiltersForm.toggleActiveFacets();
//     const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
//     FacetFiltersForm.renderPage(url);
//   }
// }

// FacetFiltersForm.filterData = [];
// FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// customElements.define('facet-filters-form', FacetFiltersForm);
// FacetFiltersForm.setListeners();

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('input')
//       .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
  
//     this.setMinAndMaxValues();
//     this.noUifilter();
//   }
//   connectedCallback(){
//     this.noUifilter();
//   }
//   onRangeChange(event) {
   
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//     this.noUifilter();
    
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     if (maxInput.value) minInput.setAttribute('max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('min', 0);
//     if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('min'));
//     const max = Number(input.getAttribute('max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }
  

//   noUifilter() {
//     var sliderRange = this.querySelector(".slider-range");
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     var minValue = parseFloat(minInput.value);
//     if (isNaN(minValue)) {
//       minValue = 0;
//     }
  
//     var event = new CustomEvent('input');
//     var form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//     if (!sliderRange.classList.contains("noUi-target")) {
//       noUiSlider.create(sliderRange, {
//         start: [minValue, maxInput.value === '' ? parseFloat(maxInput.getAttribute('max')) : parseFloat(maxInput.value)],
//         connect: true,
//         step: 1,
//         range: {
//           'min': 0,
//           'max': parseFloat(maxInput.getAttribute('max'))
//         }
//       });
//       sliderRange.noUiSlider.on("change", function(values, handle) {
//         if (handle === 0) {
//           minInput.value = values[handle];
//         }
//         if (handle === 1) {
//           maxInput.value = values[handle];
//         }
//       });
//       sliderRange.noUiSlider.on('change', function(values) {
//         form.querySelector('form').dispatchEvent(event);
//       });
  
//       minInput.addEventListener('change', function() {
//         var minValue = parseFloat(minInput.value);
//         setTimeout(function() {
//           sliderRange.noUiSlider.set([minValue, null]);
//         }, 0);
//       });
  
//       maxInput.addEventListener('change', function() {
//         var maxValue = parseFloat(maxInput.value);
//         setTimeout(function() {
//           sliderRange.noUiSlider.set([null, maxValue]);
//         }, 0);
//       });
//     }
//   }
  

// }

// customElements.define('price-range', PriceRange);

// class FacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     const facetLink = this.querySelector('a');
//     facetLink.setAttribute('role', 'button');
//     facetLink.addEventListener('click', this.closeFilter.bind(this));
//     facetLink.addEventListener('keyup', (event) => {
//       event.preventDefault();
//       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
//     });
    
//   }

//   closeFilter(event) {
//     event.preventDefault();
//     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//     form.onActiveFilterClick(event);
//   }
// }

// customElements.define('facet-remove', FacetRemove);


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const parentElement = document.querySelector('.collection-drawer-collapse-left');
    this.drawerCollapse(parentElement);
  }
  /* custom open drawer */
  drawerCollapse(parentElement) {
    if(parentElement){
      const btnOpen = this.querySelector('.drawer-collapse-btn');
      const sideBar = parentElement.querySelector('.sidebar-collapse-left');
      const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
      if (!btnOpen || !parentElement || !sideBar || !btnClose) {
        return;
      }
      btnOpen.addEventListener('click', function() {
        btnOpen.classList.toggle('open');
        sideBar.classList.toggle('open');
      });
    
      btnClose.addEventListener('click', function() {
        btnOpen.classList.remove('open');
        sideBar.classList.remove('open');
      });
    }
  }
  static closeDrawer(parentElement){
    if(parentElement){
      const btnOpen = parentElement.querySelector('.drawer-collapse-btn');
      const sideBar = parentElement.querySelector('.sidebar-collapse-left');
      const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
      btnClose.addEventListener('click', function() {
        btnOpen.classList.remove('open');
        sideBar.classList.remove('open');
      });
    }
   
  }
  
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        
      })
      .catch((e) => {
        console.error(e);
        const collection = document.getElementById('ProductGridContainer')?.querySelector('.collection');
        if (collection) collection.classList.remove('loading');
        const countContainer = document.getElementById('ProductCount');
        if (countContainer) countContainer.classList.remove('loading');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        if (countContainerDesktop) countContainerDesktop.classList.remove('loading');
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    
    
  }
  static renderReview() {
    if (window.SPR && theme.review ) {
      if ($('.shopify-product-reviews-badge').length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
      };
    }
    if(theme.review && typeof jdgm !== 'undefined' ){
      return jdgm.customizeBadges();
    }
    
  }
  static renderProductGridContainer(html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const sourceGrid = parsedHtml.getElementById('ProductGridContainer');
    const targetGrid = document.getElementById('ProductGridContainer');
    if (sourceGrid && targetGrid) {
      targetGrid.innerHTML = sourceGrid.innerHTML;
    }
  }

  static renderProductCount(html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const countElement = parsedHtml.getElementById('ProductCount');
    const countDesktopElement = parsedHtml.getElementById('ProductCountDesktop');
    const count = countElement ? countElement.innerHTML : (countDesktopElement ? countDesktopElement.innerHTML : '');
    
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const getpagi = document.querySelector('.AjaxinatePagination');
    
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      const elem = getpagi.getAttribute('data-pagination');
      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem == 'scroll' ? 'scroll' : 'click',
        callback:function(){
          if(typeof jdgm !== 'undefined') jdgm.customizeBadges();
        }
      });
    }
    if (typeof theme !== 'undefined') {
      if (theme.wishlist) theme.wishlist.load();
      if (theme.compare) theme.compare.load();
      //theme.countdown.load();
      if (theme.swatchCard2) theme.swatchCard2.load();
    }
    FacetFiltersForm.renderReview();
    
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) {
        target.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
    const parentElement = document.querySelector('.collection-drawer-collapse-left');
    FacetFiltersForm.closeDrawer(parentElement);
    
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const target = document.querySelector(selector);
      if (target) {
        target.innerHTML = activeFacetsElement.innerHTML;
      }
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.collection-category-name-title'];

    mobileElementSelectors.forEach((selector) => {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (!targetElement || !sourceElement) return;
      targetElement.innerHTML = sourceElement.innerHTML;
    });

    const formMobile = document.getElementById('FacetFiltersFormMobile');
    if (formMobile) {
      const drawer = formMobile.closest('menu-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') {
        drawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.noUiRetryCount = 0;
    this.noUiRetryTimer = null;
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
  
    this.setMinAndMaxValues();
    this.noUifilter();
  }
  connectedCallback(){
    this.noUifilter();
  }
  onRangeChange(event) {
   
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.noUifilter();
    
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
  

  noUifilter() {
    var sliderRange = this.querySelector(".slider-range");
    const inputs = this.querySelectorAll('input');
    if (!sliderRange || inputs.length < 2) return;

    if (!window.noUiSlider || typeof window.noUiSlider.create !== 'function') {
      if (this.noUiRetryCount >= 40 || this.noUiRetryTimer) return;
      this.noUiRetryCount += 1;
      this.noUiRetryTimer = window.setTimeout(() => {
        this.noUiRetryTimer = null;
        this.noUifilter();
      }, 50);
      return;
    }

    this.noUiRetryCount = 0;
    const minInput = inputs[0];
    const maxInput = inputs[1];
    var minValue = parseFloat(minInput.value);
    if (isNaN(minValue)) {
      minValue = 0;
    }
  
    var event = new CustomEvent('input');
    var form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (!sliderRange.classList.contains("noUi-target")) {
      window.noUiSlider.create(sliderRange, {
        start: [minValue, maxInput.value === '' ? parseFloat(maxInput.getAttribute('max')) : parseFloat(maxInput.value)],
        connect: true,
        step: 1,
        range: {
          'min': 0,
          'max': parseFloat(maxInput.getAttribute('max'))
        }
      });
      sliderRange.noUiSlider.on("change", function(values, handle) {
        if (handle === 0) {
          minInput.value = values[handle];
        }
        if (handle === 1) {
          maxInput.value = values[handle];
        }
      });
      sliderRange.noUiSlider.on('change', function(values) {
        form?.querySelector('form')?.dispatchEvent(event);
      });
  
      minInput.addEventListener('change', function() {
        var minValue = parseFloat(minInput.value);
        setTimeout(function() {
          sliderRange.noUiSlider.set([minValue, null]);
        }, 0);
      });
  
      maxInput.addEventListener('change', function() {
        var maxValue = parseFloat(maxInput.value);
        setTimeout(function() {
          sliderRange.noUiSlider.set([null, maxValue]);
        }, 0);
      });
    }
  }
  

}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

